import jsonata from "jsonata";
import { useEffect, useMemo, useState } from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { concatenatePaths, getObject, mapObject } from "../../util/mapObject";
import { useSideChannelSubscription } from "../../util/useSideChannel";
import applyFormatting, { useAppliedFormatter } from "../../util/applyFormatting";
import { useJnx } from "../../util/jnx";
import useOptionsLookup from "./hooks/useOptionsLookup";
import getPathFromId from "../../util/getPathFromId";
import { useDebouncedEffect } from "../../hooks/useDebounceEffect";


function LookupFormFieldTextWritable(props) {
    const {
        formContext,
        name,
        schema,
        onChange,
        value,
        idSchema: { $id },
        formData: formDataFieldValue,
    } = props;

    const {
        title,
        references,
        format = 'text',
        jsonata: jsonataComputation,
        computation,
        scope: schemaScope = '',
        onUpdate,
        lookup,
        hidden
    } = schema;

    const {
        sideChannel,
        bindings: fcBindings,
        setFormDataValues,
    } = formContext;

    const [rootFormData, formObject] = useSideChannelSubscription(sideChannel, [0, 1]) || [{}, {}];

    const {
        options: lookupOptions,
        loadingOptions,
        errorLoadingOptions
    } = useOptionsLookup({
        lookup,
        rootFormData,
        formContext
    });


    const bindings = useMemo(() => ({
        ...fcBindings,
        formObject,
        formContext
    }), [fcBindings, formObject, formContext]);

    const [current, setCurrent] = useState(null);
    useDebouncedEffect(() => {

        if (current !== value) {
            onChange(current)
        }
    }, [current], 450);
    useEffect(() => setCurrent(value), [value]);

    const path = useMemo(() => getPathFromId($id), [$id]);
    const functionBinds = useMemo(() => ({
        set: setFormDataValues,
        log: (...args) => console.log("jsonata console log\n", ...args)
    }), [setFormDataValues]);
    
    const onUpdateJnx = useJnx(onUpdate, { functionBinds });

    const valueJnx = useJnx(jsonataComputation, { functionBinds });

    useEffect(() => {
        if (valueJnx && !current) {
            try {
                const refValue = valueJnx.eval({ ...rootFormData, lookupOptions }, path, bindings);
                if (refValue !== formDataFieldValue) {
                    onChange(refValue);
                    if (onUpdateJnx) setTimeout(() => {
                        onUpdateJnx.evalAsync(rootFormData, path, { ...bindings, value: refValue });
                    }, 100);
                }
            } catch (e) {
                console.log("Computed Field error");
                console.error(e);
            }
        }
    }, [valueJnx, rootFormData, path, formDataFieldValue, lookupOptions, current]);

    const isValueComplete = useMemo(() => value !== null && value !== undefined && value !== '', [value]);


    return hidden ? null : (<FormGroup>
        {title !== " " ? <label className="control-label" htmlFor="root_preferredBranchId">
            {title}
        </label> : null}
        <Input
            disabled={isValueComplete}
            type={format}
            className="custom"
            onChange={(e) => {


                if (formDataFieldValue && !current) {
                    return null;
                }

                return setCurrent(e.target.value)
            }}
            value={formDataFieldValue || current || ""}
            readOnly={formDataFieldValue && !current}
        />
    </FormGroup>);
}


export default LookupFormFieldTextWritable;